import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { H2, Subtitle2, Body1, Body2 } from 'components/Typography';
import { Mobile, Default } from 'components/Responsive';
import styles from './styles';
import m from 'messages';
import isStringSet from 'utilities/is/isStringSet';

class Blocks extends React.Component {

    emptyMessage() {
        return (
            <Body1>
                {m.cards.blocksPresent}
            </Body1>
        );
    }

    listBlocks(blocks, classes, divisionName) {
        return (
            <React.Fragment>
                <Default>
                    <Grid container spacing={1}>
                        <Grid item sm={3}>
                            <Subtitle2>{divisionName}</Subtitle2>
                        </Grid>
                        <Grid item sm={3}>
                            <Subtitle2>{m.cards.siteName}</Subtitle2>
                        </Grid>
                        <Grid item sm={3}>
                            <Subtitle2>{m.cards.dateFrom}</Subtitle2>
                        </Grid>
                        <Grid item sm={3}>
                            <Subtitle2>{m.cards.caseNumber}</Subtitle2>
                        </Grid>
                    </Grid>
                </Default>
                {blocks.map((block, index) =>
                    <div key={index} style={{ width: '100%' }} className={classes.fullWidth}>
                        <Grid container spacing={1}>
                            <Mobile>
                                {isStringSet(block.divisionName) &&
                                    <Grid item xs={12}>
                                        <Subtitle2>
                                            {divisionName}
                                        </Subtitle2>
                                        <Body1>
                                            {block.divisionName}
                                        </Body1>
                                    </Grid>
                                }
                                {isStringSet(block.siteName) &&
                                    <Grid item xs={12}>
                                        <Subtitle2>
                                            {m.cards.siteName}
                                        </Subtitle2>
                                        <Body1>
                                            {block.siteName}
                                        </Body1>
                                    </Grid>
                                }
                                <Grid item xs={6}>
                                    <Subtitle2>
                                        {m.cards.dateFrom}
                                    </Subtitle2>
                                    <Body2>
                                        {block.dateFrom}
                                    </Body2>
                                </Grid>
                                <Grid item xs={6}>
                                    <Subtitle2>
                                        {m.cards.caseNumber}
                                    </Subtitle2>
                                    <Body2>
                                        {block.caseRefNumber}
                                    </Body2>
                                </Grid>
                            </Mobile>
                            <Default>
                                <Grid item sm={3}>
                                    <Body1>
                                        {block.divisionName}
                                    </Body1>
                                </Grid>
                                <Grid item sm={3}>
                                    <Body1>
                                        {block.siteName}
                                    </Body1>
                                </Grid>
                                <Grid item sm={3}>
                                    <Body2>
                                        {block.dateFrom}
                                    </Body2>
                                </Grid>
                                <Grid item sm={3}>
                                    <Body2>
                                        {block.caseRefNumber}
                                    </Body2>
                                </Grid>
                            </Default>
                        </Grid>
                        <Divider className={classes.divider} />
                    </div>
                )}
            </React.Fragment>
        );
    }

    render() {
        const { card, classes, divisionName } = this.props;

        const blocks = card.suspensions;
        const hasBlocks = blocks && blocks.length > 0;

        return (
            <div>
                <H2>
                    {m.cards.currentBlocksHeader}
                </H2>
                {hasBlocks ? this.listBlocks(blocks, classes, divisionName) : this.emptyMessage(classes)}
            </div>
        );
    }
}

Blocks.propTypes = {
    card: PropTypes.object.isRequired,
    divisionName: PropTypes.string.isRequired
};

export default withStyles(Blocks, styles);